import { Validators } from "@angular/forms";
import { AssignmentService } from "../../../assignment/core/assignment.service";
import { Assignment } from "../../../assignment/shared/assignment";
import { ngListService } from "../../../list/core/ng-list.service";
import { FormButtonType, FormConfig, FormField } from "./form-config-abstract";

//@FormConfig.register(EntityType.ASSIGNMENT)
export class FormConfigEditAssignment extends FormConfig<Assignment>{
    constructor(private listService : ngListService, private assignmentService : AssignmentService){
      super();
    }

    apiService = () => this.assignmentService;

    listId : number | string;

    init(listId? : number | string){
        this.listId = listId;
        super.fieldsInit(this);
    }

    buttons : FormButtonType[] = ["CANCEL", "ADD", "ADD_AND_CLOSE"];

    fields : FormField<Assignment>[] = [
      {
        name : 'citationId',
        label : 'assignment.edit.resource',
        type : 'dropdown',
        options : [],
        init : (f : FormField<Assignment>) => f.options = this.listService.getCitationsWithPDF(this.listId)
      },
      {
        name : 'title',
        label : 'assignment.new.title',
        required : true,
        type : "text",
        validators : [Validators.maxLength(250)],
        main : true
      },
      {
        name : 'description',
        label : 'assignment.edit.instructions',
        type : 'textarea',
        validators : [Validators.maxLength(3500)]
      }
      // {
      //   name : 'dueDate',
      //   label : 'assignment.edit.dueDate',
      //   type : 'date'
      // },
      // {
      //   name : 'status',
      //   label : 'assignment.edit.visibility',
      //   type : 'radio',
      //   options : [{ key: 'DRAFT', value: 'assignment.visibility.DRAFT'}, { key: 'PUBLISH', value: 'assignment.visibility.PUBLISH'}],
      //   //value : 'DRAFT'
      // },
    ]
}